import React, { useEffect, useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import { handleAddQuestion } from "../../../../APIs/Function/Workout/Q&A/AddQuestion";
import { GetSingleQuestion } from "../../../../APIs/Function/Workout/Q&A/GetSingleQuestion";

const EditQuestions = () => {
  const [options, setOptions] = useState([{ name: "Option1", value: "" }]);
  const [loading, setLoading] = useState(false);
  const [loadinga, setLoadinga] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    options: [],
  });
  const [singleQuestion, setSingleQuestion] = useState({});
  const { id } = useParams();

  const handleSingleQuestion = async () => {
    try {
      setLoadinga(true);
      let res = await GetSingleQuestion(id);
      setSingleQuestion(res.r);
      setFormData({
        ...formData,
        title: res.r.que,
        options: res.r.options,
      });
      setLoadinga(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleQuestion();
  }, []);

  const initialFormData = {
    title: "",
    options: [],
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (formData.title.trim() !== "" && formData.title !== "0") {
      try {
        setLoading(true);
        await handleAddQuestion(formData);
        setFormData(initialFormData);
        setLoading(false);
        alert("Question Added Successfully");
        navigate("/questions");
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      alert("Please Fill The question field Correctly");
    }
  };

  const addOption = () => {
    setOptions([
      ...options,
      { name: `Option${options.length + 1}`, value: "" },
    ]);
  };
  const handleOptionChange = (e, index) => {
    const newOptions = [...options];
    newOptions[index] = {
      ...newOptions[index],
      value: e.target.value,
    };
    setOptions(newOptions);
    setFormData({
      ...formData,
      options: newOptions.map((option) => ({ id: 0, option: option.value })),
    });
  };

  return (
    <>
      <Box>
        {/* header */}
        <Box
          sx={{
            bgcolor: "#31AEF4",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: { xs: "50px", md: "70px", lg: "70px" },
            p: "10px",
            boxSizing: "border-box",
          }}
        >
          <Link to={"/questions"}>
            <Box
              sx={{
                height: { xs: "50px", md: "60px", lg: "60px" },
                display: "flex",
                alignItems: "center",
              }}
            >
              <img height={"100%"} src={backbluebtn} alt="back" />
            </Box>
          </Link>
          <Box>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: { md: "30px", sm: "20px" },
                fontWeight: 600,
                lineHeight: "36px",
                color: "#FFFFFF",
              }}
            >
              Edit Questions
            </Typography>
          </Box>
          <Box>
            <CustomButton
              sx={{
                width: { xs: "40px", md: "50px", lg: "80px" },
                height: { xs: "10px", md: "50px", lg: "50px " },
              }}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress></CircularProgress> : "Save"}
            </CustomButton>
          </Box>
        </Box>
        {/* form */}
        <Container>
          <form>
            <Grid container spacing={2}>
              <Grid sx={{ m: "auto", mt: "30px" }} item xs={7}>
                <CustomInput
                  label="Add Question"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  fullWidth
                  required
                />
              </Grid>
              {singleQuestion?.options?.map((e, i) => (
                <Grid sx={{ m: "auto" }} item xs={7} key={i}>
                  <CustomInput
                    label={e.name}
                    name={e.name}
                    value={e.options} 
                    onChange={(e) => handleOptionChange(e, i)}
                    fullWidth
                  />
                </Grid>
              ))}
            </Grid>
          </form>
        </Container>

        <Box sx={{ width: "15%", m: "auto", mt: "20px" }}>
          <CustomButton
            onClick={addOption}
            sx={{
              bgcolor: "#31AEF4",
              "&:hover": {
                background: "#31AEF4",
              },
            }}
          >
            Add +
          </CustomButton>
        </Box>
      </Box>
    </>
  );
};

export default EditQuestions;
